import { useConfiguracoes } from 'hooks/configuracoes'
import { useCallback, useMemo } from 'react'

import * as ga from './ga'
import { AnalyticsEventParams, LogEventType } from './model-analytics'
import * as umami from './umami'
import { isNavegadorAmostrado, normalizarRota } from './utils-analytics'

const isSupported = () => process.env.NODE_ENV !== 'test'

let analyticsIniciado = false

export function useAnalytics() {
  const {
    configuracoes: { analytics: config },
  } = useConfiguracoes()

  const logPageview = useCallback((rota: string) => umami.logPageview(rota), [])

  const initializeAnalytics = useCallback(() => {
    if (!isSupported() || !config.enabled || analyticsIniciado) return

    const rota = normalizarRota(window.location.pathname)
    ga.init()
    ga.logPageview(rota)

    if (isNavegadorAmostrado(config.sampleRate)) umami.init(config, () => umami.logPageview(rota))

    analyticsIniciado = true
  }, [config])

  const disableAnalytics = useCallback(() => {
    umami.remove()
    ga.remove()

    analyticsIniciado = false
  }, [])

  // A rota é enviada explicitamente para evitar identificadores nos dois destinos.
  const logEvent = useCallback<LogEventType>((eventName, eventParams) => {
    const rota = normalizarRota(window.location.pathname)
    umami.logEvent(eventName, eventParams, rota)
    ga.logEvent(eventName, eventParams, rota)
  }, [])

  const setUserId = useCallback((id: string) => {
    umami.setUserId(id)
    ga.setUserId(id)
  }, [])

  const setUserProperties = useCallback((properties: AnalyticsEventParams) => {
    umami.setUserProperties(properties)
    ga.setUserProperties(properties)
  }, [])

  const analytics = useMemo(() => ({ logEvent, logPageview, setUserId, setUserProperties }), [
    logEvent,
    logPageview,
    setUserId,
    setUserProperties,
  ])

  return {
    analytics,
    initializeAnalytics,
    disableAnalytics,
  }
}
